<template>
  <div class="sales-area ">
    <div class="relative">
      <SearchComponent
        :condition="condition"
        :routeName="$route.name"
        @updateData="_updateData"
        ref="search"
      >
        <template #default="{condition,pickerOptions,searchData}">
          <div class="input-box">
            <span class="name">销售区域模板名称：</span>
            <div class="input">
              <el-input
                v-model="condition.salesAreaName"
                placeholder="请输入"
                clearable
              />
            </div>
          </div>
          <div class="input-box datepick">
            <span class="name">时间：</span>
            <div class="input">
              <el-date-picker
                v-model="condition.time"
                type="daterange"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              />
            </div>
          </div>
          <el-button
            @click="searchData"
            size="60"
            round
            class="iconfont icon-sousuo"
          />
        </template>
      </SearchComponent>
      <TableComponent
        :tableData="tableData"
        :pagination="pagination"
        :info="info"
        :dialogVisible="dialogVisible"
        :routeName="$route.name"
        @updateData="_updateData"
      >
        <template #default="{tableData,handleDelete,copyTemplate,editor}">
          <el-table
            :data="tableData"
            v-min-height
            border
            :height="500"
            :cell-style="{
              height: '20rem',
              color: '#606060'
            }"
            class="no-hover no-pad__bor"
          >
            <el-table-column align="left" width="600">
              <div slot-scope="scope">
                <span class="top-bg">
                  {{ scope.row.id }}&nbsp;&nbsp;{{ scope.row.templateName }}
                </span>
                <div class="order-details" style="padding-top: 0">
                  <div class="city">
                    {{ scope.row.areaName }}
                  </div>
                </div>
              </div>
            </el-table-column>
            <el-table-column width="auto" align="center" class-name="visible">
              <div slot-scope="scope">
                <span class="top-bg"></span>
                <el-button
                  v-permission:del="$route.meta.permission"
                  @click="handleDelete(scope.$index, scope.row)"
                  size="36"
                  class="iconfont icon-shanchu"
                  round
                />
                <el-button
                  v-permission:copy="$route.meta.permission"
                  @click="copyTemplate(scope.row)"
                  size="36"
                  class="iconfont icon-fuzhi d5"
                  round
                />
                <el-button
                  size="36"
                  v-permission:editor="$route.meta.permission"
                  class="iconfont icon-bianji"
                  @click="editor(scope.row)"
                  round
                />
              </div>
            </el-table-column>
          </el-table>
        </template>
      </TableComponent>
    </div>
  </div>
</template>
<script>
import SearchComponent from '../Components/SearchComponent'
import TableComponent from '../Components/TableComponent'
import updateData from 'mixins/updateData'

export default {
  name: 'salesArea',
  mixins: [updateData],
  components: {
    SearchComponent,
    TableComponent
  },
  data() {
    this.keyMap = {
      sales_area_list: {
        name: 'tableData',
        area_name: 'areaName',
        sales_area_id: 'id',
        sales_title: 'templateName',
        city_list: 'cityList',
        city_two: 'children',
        city_three: 'children',
        city_four: 'children'
      }
    }
    return {
      dialogVisible: false,
      condition: {
        salesAreaName: '',
        time: ''
      },
      pagination: {},
      tableData: [],
      info: {}
    }
  },
  created() {
    this._getSalesAreaList({
      curpage: 1
    })
  },
  methods: {
    /**
     * 获取销售区域模板列表
     * @param params
     * @private
     */
    _getSalesAreaList(params) {
      this.api.getSalesAreaList(params).then(res => {
        this.utils.setCommonCode(res, this)
        this.tableData = this.tableData.map(v => {
          v.cityList = v.cityList.replace(/\\/g, '')
          v.cityList = JSON.parse(v.cityList)
          return v
        })
      })
    }
  }
}
</script>
